import apiClient from './api';
import { API_ENDPOINTS } from '@/config/api.config';

class BusinessService {
  async getBusinessSettings() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.BUSINESS_SETTINGS.GET);
      return response.data;
    } catch (error) {
      console.error('Error fetching business settings:', error);
      throw error;
    }
  }

  async saveBusinessSettings(settingsData: any) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.BUSINESS_SETTINGS.UPDATE, settingsData);
      return response.data;
    } catch (error) {
      console.error('Error saving business settings:', error);
      throw error;
    }
  }
}

export const businessService = new BusinessService();
